import React from "react";
import { formatDate } from "../../utils/dates";
import { useTranslation } from "react-i18next";
import { exportJsaPdf } from "../../services/jsaService";

export default function JsaHistoryDrawer({ history, onClose, onView }) {
  const { t } = useTranslation();
  return (
    <div className="drawer">
      <h2>{t("jsa.historyTitle")}</h2>

      {history.map((jsa) => (
        <div key={jsa._id} className="history-item">
          <strong>{formatDate(jsa.date)}</strong>
          <p>
            {t("jsa.historyCounts", { tasks: jsa.tasks?.length || 0, hazards: jsa.hazards?.length || 0 })}
          </p>

          <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
            <button onClick={() => onView(jsa)}>{t("jsa.view")}</button>
            <button onClick={() => exportJsaPdf(jsa._id)}>{t("jsa.pdf")}</button>
          </div>
        </div>
      ))}

      <button onClick={onClose} style={{ marginTop: 12 }}>
        {t("jsa.close")}
      </button>
    </div>
  );
}
